import { http } from '@/utils/http';
// baseInfo
export function baseinfo(voteName: string) {
  return http.get('/vote/' + voteName + '/controller.php?enews=baseinfo');
}

// 新闻列表
export function getnewslist(voteName: string, page: number) {
  return http.get(
    '/vote/' + voteName + '/controller.php?enews=getnewslist&page=' + page,
  );
}

// 投票列表页
export function getlist(voteName: string, page?: number, data?: any) {
  return http.post(
    '/vote/' + voteName + '/controller.php?enews=getlist&page=' + page,
    data,
  );
}

// 活动规则
export function getrules(voteName: string) {
  return http.get('/vote/' + voteName + '/controller.php?enews=getrules');
}

// 判断今天这个id是否已经滑动验证过
export function needSmoothCheck(
  voteName: string,
  data: { udid: string | number | undefined },
) {
  return http.post(
    '/vote/' + voteName + '/controller.php?enews=needSmoothCheck',
    data,
  );
}

// 活动投票
export function vote(
  voteName: string,
  data: {
    id: number | string;
    udid: any;
    appkey: any;
    csessionid?: string;
    scene?: string;
    sig?: string;
    token?: string;
  },
) {
  return http.post('/vote/' + voteName + '/controller.php?enews=vote', data);
}

// 获取详情页面
export function getcontent(voteName: string, id: any) {
  return http.get(
    '/vote/' + voteName + '/controller.php?enews=getcontent&id=' + id,
  );
}

// 报名页面提交报名接口
export function save(voteName: string, data: any) {
  return http.post('/vote/' + voteName + '/controller.php?enews=save', data);
}

// 访问数据量接口;（所有活动通用;）
export function visitOne(id: number | string) {
  return http.get('/e/public/ViewClick/?classid=9&id=' + id + '&addclick=1');
}
export function visitTwo(id: number | string) {
  return http.get('/e/public/onclick/?enews=donews&classid=9&id=' + id);
}

// 服务端获取oss签名
export function getOssSignature() {
  return http.get('/oss/upload/get.php');
}

// 获取微信js sdk
export function wxSdkInfo(jssdkurl: any) {
  const prefixUrl = process.env.NODE_ENV === 'production' ? '//voteone.cqcb.com'
      : '//47.111.130.176:8019';
  return http.get(prefixUrl + '/vote/public/controller.php?enews=jssdk', {
    params: { ...jssdkurl },
  });
}
